import {
    TransactionAction,
    TransactionsActions,
} from '../actions/transactions.actions';
import { StaticTransactionsData } from '../models/static-transaction-data.model';
import { StaticTransactionsDataState } from '../state/static-transactions-data.state';

export const initialStaticTransactionsDataState: StaticTransactionsDataState = {
    null: {
        amount: '',
        fundistId: '',
        paymentButton: '',
        withdrawTo: '',
        childTransactions: [],
        parentTransactions: '',
    },
};

export function staticTransactionsDataReducer(
    state = initialStaticTransactionsDataState,
    action: TransactionAction
) {
    switch (action.type) {
        case TransactionsActions.SuccessGetTransaction:
            const newState: StaticTransactionsDataState = { ...state };

            newState[action.transactionId] = {
                ...new StaticTransactionsData(action.actions),
            };

            return newState;
        default:
            return state;
    }
}
